<template>
  <div id="app">
    <div v-if="isLtiEnabled" class="app-container p-0">
      <main class="main"><router-view /></main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useConfigStore } from "@/stores/config";
import { storeToRefs } from "pinia";

const configStore = useConfigStore();
const { isLtiEnabled } = storeToRefs(configStore);
</script>

<style lang="scss">
#app {
  background-color: var(--white);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: inherit;
  overflow: auto;
}
.app-container {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.main {
  width: 100%;
  flex: 1;
}
</style>
